<template>
  <div class="Pos_main">
    <div class="pos_all">
      <div class="UpdataMsg">*每周一更新本月天猫数据</div>
      <div class="all_nav">
        <p>Tmall 总销售额 - {{title}}</p>
        <span>更新时间: {{updateTime}}</span>
      </div>
      <PosAll :MyTimeDef2="TimeDef2" :MyTimeGone="timeGone"></PosAll>
    </div>
    <div>
      <div class="stage_nav">
        <p>Tmall 销售报告 - {{title}}</p>
        <span>Time Gone: {{timeGone}}</span>
      </div>
      <PosFull @sendtime="getUpdateTime"></PosFull>
    </div>
  </div>
</template>
<script>
import PosAll from "@/components/ButThr/ButThr_Posall";
import PosFull from "@/components/ButThr/ButThr_PosFull";

export default {
  name: "Pos",
  data() {
    return {
      updateTime: "",
      title: "",
      timeGone: "",
      TimeDef2: "",
    };
  },
  methods: {
    getTimeGone() {
      this.$addr.get("weekly/getTimeGone").then((res) => {
        this.timeGone = res.data.data;
      });
    },
    getTime() {
      this.$addr
        .post("weekly/getUpdateDate")
        .then((res) => {
          this.title = res.data.data[0].yyyymmEn;
            sessionStorage.setItem('DefTime',res.data.data[0].hostMm)
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getUpdateTime(data) {
      this.$nextTick(() => {
        this.updateTime = data[0].sumTime;
        this.TimeDef2 = data[0].TimeDef2;
      });
    },
  },
  components: {
    PosAll,
    PosFull,
  },
  beforeMount() {},
  created() {
    this.getTime();
    this.getTimeGone();
  },
};
</script>
<style  scoped>
.UpdataMsg {
  position: absolute;
  right: 5%;
  height: 20px;
  min-width: 60px;
  top: 0px;
  background: #01B198;
  z-index: 99;
  padding: 3px 8px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color:#f3f3f3;
  text-align: center;
}
.Pos_main {
  min-height: 740px;
  width: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.Pos_main .all_nav,
.Pos_main .Tmall_nav,
.Pos_main .stage_nav {
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #01B198;
  border-radius: 22.5008px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Pos_main .all_nav {
  margin: 28.8px 20px 0px 16px;
}
.Pos_main .Tmall_nav {
  margin: 0px 20px 0px 16px;
}
.Pos_main .stage_nav {
  margin: 0px 20px 10px 16px;
}

.Pos_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "PingFangSC-Medium";
  font-size: 16px;
  color: #ffffff;
}

.Pos_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  opacity: 0.6;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
  margin-right: 15px;
}
.Pos_main .pos_all {
  height: 270px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}
.pos_Tmall {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/ButThr/ButThr_all.vue